<template>
  <div>
    <el-row :gutter="5">
      <el-table
        :data="tableResult"
        style="width: 100%"
        ref="tableQuotation"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="Linha" width="100" />
        <el-table-column label="Origem" property="source">
          <template slot-scope="scope">
            {{ scope.row.data.prepost.sender.cep }}
          </template>
        </el-table-column>
        <el-table-column label="Destino" property="destiny">
          <template slot-scope="scope">
            {{ scope.row.data.prepost.delivery.cep }}
          </template>
        </el-table-column>
        <el-table-column label="Serviço" property="service">
          <template slot-scope="scope">
            {{ scope.row.data.prepost.service }}
          </template>
        </el-table-column>
        <el-table-column label="Peso" property="weight">
          <template slot-scope="scope">
            {{ scope.row.data.prepost.object.weight }}
          </template>
        </el-table-column>
        <el-table-column label="Valor" property="value">
          <template slot-scope="scope">
              {{
                scope.row.value 
                | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
              }}
            </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row :gutter="5" style="margin-top: 50px">
      <el-col
        :xs="12"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="6"
        :offset="11"
        style="display: flex; justify-content: center"
      >
        <el-button @click="back()">Voltar</el-button>
        <el-button type="info">
          <download-excel
            name="cotacao.xls"
            :data="excelExport">Exportar
          </download-excel>
        </el-button>
        <el-button
          type="primary"
          @click="create()"
          >Criar prepostagens</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  name: "QuotationObject",
  props: ["records"],
  methods: {
    back() {
      const vm = this;
      vm.$emit("back");
    },
    create() {
      const vm = this;
      if (vm.$refs.tableQuotation.selection.length === 0) {
        return this.$message({
          type: "error",
          message: "É preciso selecionar ao menos uma linha para criação das postagens",
          duration: 5000,
        });
      }
      vm.$emit("create", vm.$refs.tableQuotation.selection);
      vm.$emit("next");
    }
  },
  data() {
    return {
      tableResult: [],
      tableQuotationRef: null,
    };
  },
  computed: {
    excelExport() {
      const vm = this;
      const data = [];
      for (const record of vm.records) {
        data.push({
          "Origem": record.prepost.sender.cep,
          "Destino": record.prepost.delivery.cep,
          "Serviço": record.prepost.service,
          "Peso": record.prepost.object.weight,
          "Valor": ('' + record.prepost.value).replace('.', ','),
        })
      }
      return data;
    }
  },
  async mounted() {
    const vm = this;
    this.tableQuotationRef = this.$refs.tableQuotation;
    for (const record of vm.records) {
      vm.tableResult.push({ status: "Aguardando", value: 0, data: record });
    }
    const loading = vm.$loading(vm.$options.loading);
    for (const record of vm.tableResult) {
      record.status = "Processando";
      try {
        if (record.data.error) {
          record.status = "Erro";
          record.result = record.data.error.error;
        } else {
          record.status = "Sucesso";
          record.value = record.data.prepost.value;
        }
      } catch (e) {
        record.status = "Erro";
        record.result = e;
      }
    }
    this.$refs.tableQuotation.toggleAllSelection()
    loading.close();
  },
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
